//this keys are the formComponent name 
export type DefaultRecipeFilterEnum = 'noIngredients' | 'noCookingStep';
export type DefaultSharedRecipeFilterEnum = 'status';

export type DefaulteFilterEnum = DefaultRecipeFilterEnum | DefaultSharedRecipeFilterEnum;

export interface DefaultFilter {
  filter?: DefaulteFilterEnum;
  value?: any;
}

export type DefaultFilters = {
  [filter in DefaulteFilterEnum]?: any;
}  

export interface filterAction {
  [key: string]: () => void;
}

export const applyFilterNamePrefix = ( prefix: string | undefined, filternName: string ): string => {
  return prefix !== undefined ? prefix + filternName : filternName
}

export interface DateStruct {
  year?: number ;
  month?: number;
  day?: number;
}

export interface TimeStruct {
  hour: number;
  minute: number;
}

export const normalizeDateTime = (date: DateStruct, time?: TimeStruct): string => {
    const selectedDate = new Date(
      date.year!,
      date.month! - 1,
      date.day!,
      time && time.hour ? time.hour : 0,
      time && time.minute ? time.minute : 0
    );
    return selectedDate.toISOString();
  }